import GetFromShuffled from '../utils/GetFromShuffled';

export const gender = {
  feminine: 'feminine',
  masculine: 'masculine',
  neutral: 'neutral',
}

export default GetFromShuffled([
  {
    character: `adolescent`,
    gender: gender.neutral,
  },
  {
    character: `adventurer`,
    gender: gender.neutral,
  },
  {
    character: `bassist`,
    gender: gender.neutral,
  },
  {
    character: `child`,
    gender: gender.neutral,
  },
  {
    character: `couple`,
    gender: gender.neutral,
  },
  {
    character: `coven`,
    gender: gender.neutral,
  },
  {
    character: `daughter`,
    gender: gender.feminine,
  },
  {
    character: `dictator`,
    gender: gender.neutral,
  },
  {
    character: `divorcée`,
    gender: gender.feminine,
  },
  {
    character: `doctor`,
    gender: gender.neutral,
  },
  {
    character: `extended family`,
    gender: gender.neutral
  },
  {
    character: `felon`,
    gender: gender.neutral,
  },
  {
    character: `ghost`,
    gender: gender.neutral,
  },
  {
    character: `house sitter`,
    gender: gender.neutral
  },
  {
    character: `international super spy`,
    gender: gender.neutral,
  },
  {
    character: `jockey`,
    gender: gender.neutral,
  },
  {
    character: `klansman`,
    gender: gender.masculine,
  },
  {
    character: `longshoreman`,
    gender: gender.masculine,
  },
  {
    character: `man`,
    gender: gender.masculine,
  },
  {
    character: `mistress`,
    gender: gender.feminine,
  },
  {
    character: `mother`,
    gender: gender.feminine,
  },
  {
    character: `murder detective`,
    gender: gender.neutral,
  },
  {
    character: `nanny`,
    gender: gender.neutral,
  },
  {
    character: `NEET`,
    gender: gender.neutral,
  },
  {
    character: `nurse`,
    gender: gender.neutral,
  },
  {
    character: `octogenarian`,
    gender: gender.neutral,
  },
  {
    character: `orphan`,
    gender: gender.neutral,
  },
  {
    character: `private investigator`,
    gender: gender.neutral,
  },
  {
    character: `professor`,
    gender: gender.neutral,
  },
  {
    character: `soldier`,
    gender: gender.neutral,
  },
  {
    character: `starship captain`,
    gender: gender.neutral,
  },
  {
    character: `student`,
    gender: gender.neutral,
  },
  {
    character: `talent director`,
    gender: gender.neutral,
  },
  {
    character: `vampire`,
    gender: gender.neutral,
  },
  {
    character: `widow`,
    gender: gender.feminine,
  },
  {
    character: `woman`,
    gender: gender.feminine,
  },
  {
    character: `writer`,
    gender: gender.neutral,
  },
])
